import { ModelType } from "types/models";
import app, { storeName as appStoreName } from "store/model/app.model";

export const model: ModelType = {
  [appStoreName]: app,
};
